import starIcon from '../assets/img/star-icon.svg';
import store from '../assets/img/store.png'

export const MARKETPLACE = [
    {
        id: 0,
        name: 'Online',
        img: starIcon,
        price: 10,
        inv: 15
    },
    {
        id: 1,
        name: 'In-person',
        img: store,
        price: 10,
        inv: 15
    },
    // {
    //     id: 2,
    //     name: 'Item3',
    //     img: starIcon,
    //     price: 10,
    //     inv: 15
    // },
    // {
    //     id: 3,
    //     name: 'Item4',
    //     img: starIcon,
    //     price: 10,
    //     inv: 15
    // },
    // {
    //     id: 4,
    //     name: 'Item5',
    //     img: starIcon,
    //     price: 10,
    //     inv: 15
    // },
    // {
    //     id: 5,
    //     name: 'Item6',
    //     img: starIcon,
    //     price: 10,
    //     inv: 15
    // },
];